import { Box, BoxProps } from "@chakra-ui/react";

export function ImageIcon({ ...props }: BoxProps) {
  return (
    <Box {...props}>
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="8.125"
          cy="8.125"
          r="1.625"
          stroke="#1819B4"
          stroke-width="1.625"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.70898 13.0007C2.70898 8.14911 2.70898 5.72334 4.21616 4.21616C5.72334 2.70898 8.14911 2.70898 13.0007 2.70898C17.8522 2.70898 20.278 2.70898 21.7851 4.21616C23.2923 5.72334 23.2923 8.14911 23.2923 13.0007C23.2923 17.8522 23.2923 20.278 21.7851 21.7851C20.278 23.2923 17.8522 23.2923 13.0007 23.2923C8.14911 23.2923 5.72334 23.2923 4.21616 21.7851C2.70898 20.278 2.70898 17.8522 2.70898 13.0007Z"
          stroke="#1819B4"
          stroke-width="1.625"
        />
        <path
          d="M5.41602 22.7499C10.1528 17.0895 15.4629 9.62434 23.2883 14.6709"
          stroke="#1819B4"
          stroke-width="1.625"
        />
      </svg>
    </Box>
  );
}
